/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action, computed } from '@ember/object';
import { htmlSafe } from '@ember/template';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import LogModel from 'cio/models/log';
import FacebookLeadAdsForm from 'cio/models/facebook-lead-ads-form';
import CustomForm from 'cio/models/custom-form';
import AnalyticsService from 'cio/services/analytics';
import { isCustomForm } from 'cio/utils/forms';

interface EventLogsStatusArgs {
  eventLogs: LogModel[];
  totalLogs: LogModel[];
  event: string;
  form: FacebookLeadAdsForm | CustomForm;
  isDataFilter: boolean;
  isRunning: boolean;
  isError: boolean;
  readonly: boolean;
  refetchLogs?: () => unknown;
  oldUI?: boolean; // Remove once Campaign Trigger switches completely to new UI
  asBanner?: boolean;
  asButton?: boolean;
}

export default class EventLogsStatus extends Component<EventLogsStatusArgs> {
  @service analytics!: AnalyticsService;

  @tracked log: LogModel | null = null;
  @tracked isShowingEventDataModal = false;
  @tracked isShowingSendTestEventModal = false;

  @computed('args.{form.name,eventLogs}')
  get filterTitle() {
    return htmlSafe(
      `<span>${this.args.eventLogs.length}
      submissions for <b>${this.args.form.name}</b> form</span>`,
    );
  }

  @action
  onSendTestWithLog(log: LogModel) {
    this.log = log;
    this.isShowingSendTestEventModal = true;
    this.isShowingEventDataModal = false;
  }

  @action
  onCloseModal() {
    this.log = null;
    this.isShowingSendTestEventModal = false;
    this.isShowingEventDataModal = false;
  }

  @action
  openTestEventModal() {
    this.isShowingSendTestEventModal = true;
    this.analytics.track('events', 'send_started', {
      source: isCustomForm(this.args.form) ? 'Custom Forms' : 'FB Lead Ads Test',
    });
  }
}
